import { Component, forwardRef, inject, OnDestroy, OnInit } from '@angular/core';
import {
  MatAccordion,
  MatExpansionPanel,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle
} from "@angular/material/expansion";
import {
  RecordsTableContainerComponent
} from "../../../core/components/records-table-container/records-table-container.component";
import { DropdownSettingsStateService } from "../../../core/services/dropdown-settings-state.service";
import {
  WrapperElementSizeStateService
} from "../../../core/services/table-services/wrapper-element-size-state.service";
import { ColumnParamsStateService } from "../../../core/services/table-services/column-params-state.service";
import { dropdownSettingsResources, DropdownSettingsResourceType } from "../../../core/models/resource/tables/dropdown-settings-resource-type";

@Component({
  selector: 'app-dropdown-settings-page',
  imports: [
    MatAccordion,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    RecordsTableContainerComponent,
    forwardRef(() => RecordsTableContainerComponent)
  ],
  templateUrl: './dropdown-settings-page.component.html',
  styleUrl: './dropdown-settings-page.component.scss'
})
export class DropdownSettingsPageComponent implements OnInit, OnDestroy {
  private dropdownSettingsStateService: DropdownSettingsStateService = inject(DropdownSettingsStateService);
  private wrapperElementSizeStateService: WrapperElementSizeStateService = inject(WrapperElementSizeStateService);
  private columnParamsStateService: ColumnParamsStateService = inject(ColumnParamsStateService);

  public readonly dropdownSettingsResources = dropdownSettingsResources;
  public dropdownResourceKeys = Object.keys(dropdownSettingsResources) as Array<DropdownSettingsResourceType>;

  public ngOnInit() {
    this.dropdownSettingsStateService.dropdownSettingsPageOpen();
  }

  public ngOnDestroy() {
    this.dropdownSettingsStateService.dropdownSettingsPageClose();
    this.dropdownResourceKeys.forEach((key: string) => {
      this.wrapperElementSizeStateService.resetSpecificWrapperElementSize(key);
      this.columnParamsStateService.resetTableColumnParamsState(key);
    });
  }
}
